var _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPreviewBg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 362,
    height: 518,
    viewBox: "0 0 362 518",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M319.67 46.1H310.25",
    stroke: "black",
    strokeWidth: 2.05,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.96 41.39V50.81",
    stroke: "black",
    strokeWidth: 2.05,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.67 126.95H310.25",
    stroke: "black",
    strokeWidth: 2.05,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.96 122.24V131.65",
    stroke: "black",
    strokeWidth: 2.05,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.67 211.99H310.25",
    stroke: "black",
    strokeWidth: 2.05,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.96 207.28V216.7",
    stroke: "black",
    strokeWidth: 2.05,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.67 297.04H310.25",
    stroke: "black",
    strokeWidth: 2.05,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.96 292.33V301.74",
    stroke: "black",
    strokeWidth: 2.05,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.67 382.08H310.25",
    stroke: "black",
    strokeWidth: 2.05,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.96 377.37V386.79",
    stroke: "black",
    strokeWidth: 2.05,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.67 467.13H310.25",
    stroke: "black",
    strokeWidth: 2.05,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.96 462.42V471.83",
    stroke: "black",
    strokeWidth: 2.05,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.87 46.1H220.45",
    stroke: "black",
    strokeWidth: 2.05,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.16 41.39V50.81",
    stroke: "black",
    strokeWidth: 2.05,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.87 126.95H220.45",
    stroke: "black",
    strokeWidth: 2.05,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.16 122.24V131.65",
    stroke: "black",
    strokeWidth: 2.05,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.87 211.99H220.45",
    stroke: "black",
    strokeWidth: 2.05,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.16 207.28V216.7",
    stroke: "black",
    strokeWidth: 2.05,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.87 297.04H220.45",
    stroke: "black",
    strokeWidth: 2.05,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.16 292.33V301.74",
    stroke: "black",
    strokeWidth: 2.05,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.87 382.08H220.45",
    stroke: "black",
    strokeWidth: 2.05,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.16 377.37V386.79",
    stroke: "black",
    strokeWidth: 2.05,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.87 467.13H220.45",
    stroke: "black",
    strokeWidth: 2.05,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.16 462.42V471.83",
    stroke: "black",
    strokeWidth: 2.05,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.07 46.1H130.65",
    stroke: "black",
    strokeWidth: 2.05,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.36 41.39V50.81",
    stroke: "black",
    strokeWidth: 2.05,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.07 126.95H130.65",
    stroke: "black",
    strokeWidth: 2.05,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.36 122.24V131.65",
    stroke: "black",
    strokeWidth: 2.05,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.07 211.99H130.65",
    stroke: "black",
    strokeWidth: 2.05,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.36 207.28V216.7",
    stroke: "black",
    strokeWidth: 2.05,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.07 297.04H130.65",
    stroke: "black",
    strokeWidth: 2.05,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.36 292.33V301.74",
    stroke: "black",
    strokeWidth: 2.05,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.07 382.08H130.65",
    stroke: "black",
    strokeWidth: 2.05,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.36 377.37V386.79",
    stroke: "black",
    strokeWidth: 2.05,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.07 467.13H130.65",
    stroke: "black",
    strokeWidth: 2.05,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.36 462.42V471.83",
    stroke: "black",
    strokeWidth: 2.05,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.27 46.1H40.85",
    stroke: "black",
    strokeWidth: 2.05,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.5601 41.39V50.81",
    stroke: "black",
    strokeWidth: 2.05,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.27 126.95H40.85",
    stroke: "black",
    strokeWidth: 2.05,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.5601 122.24V131.65",
    stroke: "black",
    strokeWidth: 2.05,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.27 211.99H40.85",
    stroke: "black",
    strokeWidth: 2.05,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.5601 207.28V216.7",
    stroke: "black",
    strokeWidth: 2.05,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.27 297.04H40.85",
    stroke: "black",
    strokeWidth: 2.05,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.5601 292.33V301.74",
    stroke: "black",
    strokeWidth: 2.05,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.27 382.08H40.85",
    stroke: "black",
    strokeWidth: 2.05,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.5601 377.37V386.79",
    stroke: "black",
    strokeWidth: 2.05,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.27 467.13H40.85",
    stroke: "black",
    strokeWidth: 2.05,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.5601 462.42V471.83",
    stroke: "black",
    strokeWidth: 2.05,
    strokeMiterlimit: 10
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.05
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.319946 46.1H5.43994",
    stroke: "black",
    strokeWidth: 2.05,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.46 46.1H351.13",
    stroke: "black",
    strokeWidth: 2.05,
    strokeMiterlimit: 10,
    strokeDasharray: "10.02 10.02"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.14 46.1H361.26",
    stroke: "black",
    strokeWidth: 2.05,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.319946 126.77H5.43994",
    stroke: "black",
    strokeWidth: 2.05,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.46 126.77H351.13",
    stroke: "black",
    strokeWidth: 2.05,
    strokeMiterlimit: 10,
    strokeDasharray: "10.02 10.02"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.14 126.77H361.26",
    stroke: "black",
    strokeWidth: 2.05,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.319946 211.92H5.43994",
    stroke: "black",
    strokeWidth: 2.05,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.46 211.92H351.13",
    stroke: "black",
    strokeWidth: 2.05,
    strokeMiterlimit: 10,
    strokeDasharray: "10.02 10.02"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.14 211.92H361.26",
    stroke: "black",
    strokeWidth: 2.05,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.319946 297.08H5.43994",
    stroke: "black",
    strokeWidth: 2.05,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.46 297.08H351.13",
    stroke: "black",
    strokeWidth: 2.05,
    strokeMiterlimit: 10,
    strokeDasharray: "10.02 10.02"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.14 297.08H361.26",
    stroke: "black",
    strokeWidth: 2.05,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.319946 382.23H5.43994",
    stroke: "black",
    strokeWidth: 2.05,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.46 382.23H351.13",
    stroke: "black",
    strokeWidth: 2.05,
    strokeMiterlimit: 10,
    strokeDasharray: "10.02 10.02"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.14 382.23H361.26",
    stroke: "black",
    strokeWidth: 2.05,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.319946 466.94H5.43994",
    stroke: "black",
    strokeWidth: 2.05,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.46 466.94H351.13",
    stroke: "black",
    strokeWidth: 2.05,
    strokeMiterlimit: 10,
    strokeDasharray: "10.02 10.02"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.14 466.94H361.26",
    stroke: "black",
    strokeWidth: 2.05,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.5601 0.109985V5.21999",
    stroke: "black",
    strokeWidth: 2.05,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.5601 15.58V507.51",
    stroke: "black",
    strokeWidth: 2.05,
    strokeMiterlimit: 10,
    strokeDasharray: "10.36 10.36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.5601 512.68V517.8",
    stroke: "black",
    strokeWidth: 2.05,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.64 0.109985V5.21999",
    stroke: "black",
    strokeWidth: 2.05,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.64 15.58V507.51",
    stroke: "black",
    strokeWidth: 2.05,
    strokeMiterlimit: 10,
    strokeDasharray: "10.36 10.36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.64 512.68V517.8",
    stroke: "black",
    strokeWidth: 2.05,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.28 0.109985V5.21999",
    stroke: "black",
    strokeWidth: 2.05,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.28 15.58V507.51",
    stroke: "black",
    strokeWidth: 2.05,
    strokeMiterlimit: 10,
    strokeDasharray: "10.36 10.36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.28 512.68V517.8",
    stroke: "black",
    strokeWidth: 2.05,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.91 0.109985V5.21999",
    stroke: "black",
    strokeWidth: 2.05,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.91 15.58V507.51",
    stroke: "black",
    strokeWidth: 2.05,
    strokeMiterlimit: 10,
    strokeDasharray: "10.36 10.36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.91 512.68V517.8",
    stroke: "black",
    strokeWidth: 2.05,
    strokeMiterlimit: 10
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreviewBg);
export default __webpack_public_path__ + "static/media/preview-bg.dc513b99c26c479765e39b0ae2b9e5b5.svg";
export { ForwardRef as ReactComponent };